module.exports = __webpack_public_path__ + "assets/units/shouts/Mangler.ogg";